<template>
  <div class="control-section">
    <div align='center'>
      <ejs-chart ref='chart' style='display:block' align='center' id='chartcontainer' :height='height' :title='title' :primaryXAxis='primaryXAxis'
                 :primaryYAxis='primaryYAxis' :chartArea='chartArea' :width='width' :tooltip='tooltip' :legendSettings='legend' :zoomSettings='zoomSettings' selectionMode='DragX' :chartMouseClick="chartMouseClick">
        <e-series-collection>
          <e-series :dataSource='seriesData' type='Column' xName='x' yName='y' :name='$t("TS.callSetUpTimeStatistics")' width=2 :marker='marker' fill='#3BA1FF' > </e-series>
        </e-series-collection>
      </ejs-chart>
    </div>
    <CustomDialog ref='searchPage' :element='dialog.element.eleSearch' :styles='dialog.stylesSearch' :messages='dialog.messages.search'>
      <template v-slot:dialog-content>
        <QueryDataDialog ref="query"></QueryDataDialog>
      </template>
    </CustomDialog>
    <CustomDialog ref='singleCallSetUpTimePage' :element='dialog.element.eleSingle' :styles='dialog.stylesDetail' :messages='dialog.messages.single'>
      <template v-slot:dialog-content>
        <SingleSetUpTimeDialog ref="querySingleDetail" v-model="singledata"></SingleSetUpTimeDialog>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
import Vue from 'vue';
import { Browser } from '@syncfusion/ej2-base';
import { ChartPlugin, ColumnSeries, Category, DataLabel, Tooltip, Legend, Zoom, ScrollBar, Selection } from '@syncfusion/ej2-vue-charts';
import CustomDialog from '../../common/CustomDialog';
import QueryDataDialog from '../QueryDataDialog';
import ConfigCallSetUpTimeRangeDialog from './ConfigCallSetUpTimeRangeDialog';
import SingleSetUpTimeDialog from './SingleSetUpTimeDialog';
import Global from '../Global';
import { EventBus } from '../../../plugins/eventBus';
import bus from '../bus.js';
Vue.use(ChartPlugin);

export default Vue.extend({
  name: 'CallSetUpTimeChart',
  components: {
    CustomDialog,
    QueryDataDialog,
    ConfigCallSetUpTimeRangeDialog,
    SingleSetUpTimeDialog
  },
  data() {
    return {
      // $maximum: 0,

      neId: '',
      singledata: '',
      seriesData: [],
      olapUrl: Global.olapUrl,
      searchConditions: '',
      // seriesData: [
      //    { x: '00:00~01:00', y: 37 }, { x: '01:00~02:00', y: 23 }, { x: '02:00~03:00', y: 18 },{ x: '03:00~04:00', y: 16 },{ x: '04:00~05:00', y: 16 },{ x: '05:00~06:00', y: 37 }, { x: '06:00~07:00', y: 23 }, { x: '07:00~08:00', y: 18 },{ x: '08:00~09:00', y: 46 }, { x: '09:00~10:00', y: 27 }, { x: '10:00~11:00', y: 26 },{ x: '11:00~12:00', y: 46 }, { x: '12:00~13:00', y: 27 }, { x: '13:00~14:00', y: 56 },{ x: '14:00~15:00', y: 46 }, { x: '15:00~16:00', y: 27 }, { x: '17:00~18:00', y: 56 },{ x: '18:00~19:00', y: 46 }, { x: '19:00~20:00', y: 27 }, { x: '20:00~21:00', y: 56 },{ x: '21:00~22:00', y: 46 }, { x: '22:00~23:00', y: 27 }
      //  ],
      primaryXAxis: {
        valueType: 'Category',
        zoomFactor: 0.99,
        zoomPosition: 0,
        majorGridLines: { width: 0 },
        edgeLabelPlacement: 'Shift',
        title: this.$t('TS.ts_xAxis_time')
      },
      primaryYAxis:
        {
          title: this.$t('TS.ts_average_time'),
          minimum: 0,
          // maximum: (this.$maximum < 10 ? 10 : null),
          maximum: 10,
          labelFormat: '{value}'
        },
      height: Browser.isDevice ? '100%' : '650px',
      width: Browser.isDevice ? '100%' : '60%',
      /* 柱形图上显示对应的值，测试部提出显示不友好，所有现在是隐藏状态 */
      marker:
        { dataLabel:
            { visible: false, position: 'Top', font: { fontWeight: '600', color: '#ffffff' }
            }
        },
      tooltip: {
        enable: true
      },
      legend: {
        visible: true,
        position: 'Top'
      },
      zoomSettings: {
        mode: 'X',
        enableMouseWheelZooming: true,
        enablePinchZooming: true,
        // enableSelectionZooming: true,
        enableScrollbar: true,
        toolbarItems: ['ZoomIn', 'ZoomOut']
      },
      chartArea: {
        border: {
          width: 0
        }
      },
      title: this.$t('TS.callSetUpTimeStatistics'),
      dialog: {
        styles: {
          width: '40%',
          height: '50%',
          visible: false,
          model: true
        },
        stylesSearch: {
          width: '40%',
          height: '70%',
          visible: false,
          model: true
        },
        stylesDetail: {
          width: '95%',
          height: '78%',
          zIndex: 1100,
          visible: false,
          model: true
        },
        element: {
          eleSearch: {
            target: this.$refs.callSetUpTimeChart,
            refName: 'eleSearch',
            buttonGroup: [
              { click: this.closeSearch, buttonModel: { content: this.$t('TS.ts_cancell') } },
              { click: this.queryConfirmFunc, buttonModel: { content: this.$t('TS.ts_ok'), isPrimary: true } }
            ],
            title: this.$t('TS.ts_search'),
            isClose: true
          },
          eleSingle: {
            target: this.$refs.callSetUpTimeChart,
            refName: 'eleSingle',
            buttonGroup: [
              { click: this.closeSinglePage, buttonModel: { content: this.$t('TS.ts_cancell') } }
            ],
            title: this.$t('TS.ts_call_detail'),
            isClose: true
          }
        },
        messages: {
          search: {
            title: this.$t('TS.gs_search')
          },
          single: {
            title: this.$t('TS.ts_call_detail')
          }
        }
      }
    };
  },
  provide: {
    chart: [ColumnSeries, Legend, DataLabel, Category, Tooltip, Zoom, ScrollBar, Selection]
  },
  methods: {
    chartMouseClick(args) {
      const doc = document.getElementById(args.target).getAttribute('aria-label');
      if (doc !== null) {
        const index = doc.lastIndexOf(':');
        const xAxisLabel = doc.substr(0, index);
        const params = {
          timeInterval: this.searchConditions.timeInterval,
          neId: this.searchConditions.neId,
          startdate: this.searchConditions.startdate,
          enddate: this.searchConditions.enddate,
          xAxisValue: xAxisLabel
        };
        if (xAxisLabel === '') {
          return;
        }
        this.$refs.querySingleDetail.getData(params);
        bus.$emit('callDetail', params);
        this.$refs.singleCallSetUpTimePage.show();
      }
    },
    setSinglePage() {
      this.$refs.singleCallSetUpTimePage.show();
    },
    closeSinglePage() {
      this.$refs.singleCallSetUpTimePage.clear();
      this.$refs.singleCallSetUpTimePage.close();
    },
    searchPage() {
      this.$refs.searchPage.show();
      return null;
    },
    closeSearch() {
      this.$refs.searchPage.clear();
      this.$refs.searchPage.close();
    },
    queryConfirmFunc() {
      const This = this;
      this.searchConditions = This.$refs.query.getSearchCondition();
      console.log(this.searchConditions);
      this.neId = this.searchConditions.neId;
      if (this.searchConditions) {
        const OLAP_URL = `${This.olapUrl}/lte/ems/olap/voice/getCallSetupTimeLength.html?startDate=${this.searchConditions.startdate}&endDate=${this.searchConditions.enddate}&interval=${this.searchConditions.timeInterval}&neId=${this.searchConditions.neId}`;
        // const OLAP_URL = `/olap/lte/ems/olap/voice/getCallSetupTimeLength.html?startDate=${this.searchConditions.startdate}&endDate=${this.searchConditions.enddate}&interval=${this.searchConditions.timeInterval}&neId=${this.searchConditions.neId}`;
        /* const data = {"yAxis":[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,20,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0],"xAxis":["00:00~00:15","00:15~00:30","00:30~00:45","00:45~01:00","01:00~01:15","01:15~01:30","01:30~01:45","01:45~02:00","02:00~02:15","02:15~02:30","02:30~02:45","02:45~03:00","03:00~03:15","03:15~03:30","03:30~03:45","03:45~04:00","04:00~04:15","04:15~04:30","04:30~04:45","04:45~05:00","05:00~05:15","05:15~05:30","05:30~05:45","05:45~06:00","06:00~06:15","06:15~06:30","06:30~06:45","06:45~07:00","07:00~07:15","07:15~07:30","07:30~07:45","07:45~08:00","08:00~08:15","08:15~08:30","08:30~08:45","08:45~09:00","09:00~09:15","09:15~09:30","09:30~09:45","09:45~10:00","10:00~10:15","10:15~10:30","10:30~10:45","10:45~11:00","11:00~11:15","11:15~11:30","11:30~11:45","11:45~12:00","12:00~12:15","12:15~12:30","12:30~12:45","12:45~13:00","13:00~13:15","13:15~13:30","13:30~13:45","13:45~14:00","14:00~14:15","14:15~14:30","14:30~14:45","14:45~15:00","15:00~15:15","15:15~15:30","15:30~15:45","15:45~16:00","16:00~16:15","16:15~16:30","16:30~16:45","16:45~17:00","17:00~17:15","17:15~17:30","17:30~17:45","17:45~18:00","18:00~18:15","18:15~18:30","18:30~18:45","18:45~19:00","19:00~19:15","19:15~19:30","19:30~19:45","19:45~20:00","20:00~20:15","20:15~20:30","20:30~20:45","20:45~21:00","21:00~21:15","21:15~21:30","21:30~21:45","21:45~22:00","22:00~22:15","22:15~22:30","22:30~22:45","22:45~23:00","23:00~23:15","23:15~23:30","23:30~23:45","23:45~00:00"]};
        const dataArr = [];
        for (let i = 0; i < data.xAxis.length; i++) {
          const obj = {
            x: data.xAxis[i],
            y: data.yAxis[i]
          };
          dataArr.push(obj);
        }
        This.seriesData = dataArr;
        This.$refs.searchPage.close(); */
        This.$loading.showLoadding(this.$t('MML.loadingTip'));
        This.$axios.get(OLAP_URL).then((response) => {
          if (response && response.status === 200) {
            const resultContent = response.data;
            const dataArr = [];
            let $ymaximum = 0;
            for (let i = 0; i < resultContent.xAxis.length; i++) {
              const obj = {
                x: resultContent.xAxis[i],
                y: resultContent.yAxis[i]
              };
              dataArr.push(obj);
              const yValue = resultContent.yAxis[i];
              $ymaximum = ($ymaximum < yValue) ? yValue : $ymaximum;
            }
            This.seriesData = dataArr;
            $ymaximum = ($ymaximum < 10) ? 10 : null;
            const newYAxis = {
              title: this.$t('TS.ts_average_time'),
              maximum: $ymaximum,
              labelFormat: '{value}'
            };
            This.primaryYAxis = newYAxis;
            let zoomFactor = 0.99;
            if (resultContent.xAxis.length > 6) {
              zoomFactor = (6 / resultContent.xAxis.length).toFixed(2);
            }
            const newPrimaryXAxis = {
              valueType: 'Category',
              zoomFactor: zoomFactor,
              zoomPosition: 0,
              interval: 1,
              majorGridLines: { width: 0 },
              edgeLabelPlacement: 'Shift',
              title: this.$t('TS.ts_xAxis_time')
            };
            This.primaryXAxis = newPrimaryXAxis;
          }
          This.closeSearch();
          This.$loading.hideLoadding();
        }).catch(err => {
          This.$loading.hideLoadding();
        });
      }
    }
  }
});
</script>

<style scoped>

</style>
